// ************************************************************************************************************************************************************
//
// CONFIDENTIAL
// Unpublished Work, Copyright 2023, Baxter Healthcare Corporation. All rights reserved.
// For use only by Baxter Healthcare Corporation.
// This document contains proprietary information. It must not be reproduced
// or disclosed to others without prior written approval.
//
// Filename: DashboardPage.js
// Description: This file is responsible for Dashboard component and Content Route
//
// ************************************************************************************************************************************************************
import React from "react";
import { connect } from "react-redux";
import { Redirect, Router } from "react-router";
import { ContentRoute } from "../../_metronic/layout";
import history from "../history";
import Usermanual from "../modules/Usermanual/Usermanual";
import Users from "../modules/Users/Users";
import Monitors from "../modules/Monitors/Monitors";
import FacilityList from "../modules/Facilities/FacilityList";
import MonitorDetails from "../modules/Monitors/MonitorDetails";
import FacilitiesDetails from "../modules/Facilities/FacilitiesDetails";
import IdleTimer from "react-idle-timer";
import { OktaAuth } from "@okta/okta-auth-js";
import { MenuPath } from "../../Application_Constants";

class DashboardPage extends React.Component {
  oktaAuth = new OktaAuth({
    issuer: process.env.REACT_APP_OKTA_DOMAIN,
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID
  });

  constructor(props) {
    super(props);
    this.state = {
      timeout: 900000,
      showModal: false,
      userLoggedIn: false,
      isTimedOut: false
    };
    this.idleTimer = null;
    this.onAction = this._onAction.bind(this);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
  }

  componentDidUpdate() {}

  _onAction(e) {
    this.setState({ isTimedOut: false });
  }

  _onActive(e) {
    this.setState({ isTimedOut: false });
  }

  _onIdle(e) {
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      this.oktaAuth.signOut();
    } else {
      this.setState({ showModal: true });
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  render() {
    return (
      <div className="wrapper-div">
        <div className="row">
          <IdleTimer
            ref={(ref) => {
              this.idleTimer = ref;
            }}
            element={document}
            onActive={this.onActive}
            onIdle={this.onIdle}
            onAction={this.onAction}
            debounce={250}
            timeout={this.state.timeout}
          />

          <>
            <div
              className="col-xs-12 col-sm-12 col-lg-12 mainDiv"
              style={
                this.props.monitorDetails
                  ? {
                      backgroundColor: "#fffff"
                    }
                  : null
              }
            >
              <div className="row">
                <div
                  className="col-xs-12"
                  style={{
                    marginTop: "0.6%",
                    backgroundColor: "#fffff",
                    padding: "0%",
                    paddingRight: "12px"
                  }}
                >
                  <Router history={history}>
                    <ContentRoute
                      path="/dashboard/monitor-details/:id"
                      component={MonitorDetails}
                    />
                    <ContentRoute
                      path="/dashboard/facility-details/:id"
                      component={FacilitiesDetails}
                    />

                    <ContentRoute
                      path={MenuPath.MONITOR_ALL}
                      exact={true}
                      component={Monitors}
                    />

                    <ContentRoute
                      path={MenuPath.MONITOR_ASSIGNED}
                      exact={true}
                      component={Monitors}
                    />

                    <ContentRoute
                      path={MenuPath.MONITOR_UNASSIGNED}
                      exact={true}
                      component={Monitors}
                    />

                    <ContentRoute
                      path={MenuPath.MONITOR_DELETED}
                      exact={true}
                      component={Monitors}
                    />

                    <ContentRoute path={MenuPath.USER_ALL} component={Users} />

                    <ContentRoute
                      path={MenuPath.USER_INACTIVE}
                      component={Users}
                    />
                    <ContentRoute
                      path={MenuPath.USER_ACTIVE}
                      component={Users}
                    />

                    <ContentRoute path={MenuPath.HELP} component={Usermanual} />

                    <ContentRoute
                      path={MenuPath.FACILITY_ALL}
                      component={FacilityList}
                    />

                    <Redirect
                      from="/dashboard"
                      exact={true}
                      to={MenuPath.MONITOR_ALL}
                    />
                    <Redirect to={MenuPath.MONITOR_ALL} />
                  </Router>
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedMenu: state.selectedMenu,
    isSearchBar: state.isSearchBar,
    selectedFacility: state.selectedFacility,
    monitorDetails: state.monitorDetails,
    facilityDetails: state.facilityDetails,
    facilityName: state.facilityName,
    usermanual: state.userManual
  };
}

export default connect(mapStateToProps, null)(DashboardPage);
